import { ListResult } from '../../../shared/models/api-results/base.api-result';
import { FeatureFlagResult } from '../../../shared/models/api-results/feature-flag.api-result';
import { ListStudentSettingsResult } from '../../../shared/models/api-results/student-setting.api-result';
import { StudentResult } from '../../../shared/models/api-results/student.api-result';
import { ListSubscriptionsResult } from '../../../shared/models/api-results/subscription.api-result';
import { WriterResult } from '../../../shared/models/api-results/writer.api-result';
import { CallState, LoadingState } from '../../../shared/models/interfaces/call-state.interface';

export interface AuthState {
  initializing: boolean;
  refreshingToken: boolean;
  student: StudentResult;
  studentSettings: ListStudentSettingsResult;
  activeSubscriptions: ListSubscriptionsResult;
  writer: WriterResult;
  featureFlags: ListResult<FeatureFlagResult>;

  loginState: CallState;
  pathToReachAfterLogin: string;

  isInMaintenance: boolean;

  justRegisteredWithSSO: boolean;

  impersonateUser: StudentResult;
  examTestingState: {
    examId: string;
    folderId?: string;
    examContentSessionId: string;
  };
}

export const initialAuthState: AuthState = {
  initializing: true,
  refreshingToken: false,
  student: undefined,
  studentSettings: undefined,
  activeSubscriptions: undefined,
  writer: undefined,
  featureFlags: undefined,

  loginState: LoadingState.INIT,
  pathToReachAfterLogin: undefined,

  isInMaintenance: false,

  justRegisteredWithSSO: false,

  impersonateUser: undefined,
  examTestingState: undefined,
};
